import adminApiClient from '@/services/admin/api.admin';
import ADMIN_API_ENDPOINTS from '@/services/admin/endpoints.admin';
async function list() {
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_SUBCATEGORIES.BASE);
}
async function create(body) {
    return adminApiClient.post(ADMIN_API_ENDPOINTS.LOCATION_SUBCATEGORIES.BASE, body);
}
async function remove(locationId, subcategoryId) {
    return adminApiClient.delete(ADMIN_API_ENDPOINTS.LOCATION_SUBCATEGORIES.BY_LOCATION_AND_SUBCATEGORY(locationId, subcategoryId));
}
export default {
    list,
    create,
    remove
};
